var toObject = require('../internals/to-object');

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/has.js
// module id = 9
// module chunks = 0